import get from 'lodash/get';

export const selectLogMeLastWorkspaceUsed = (state) => get(state, 'settings.loginSettings.logMeLastWorkspaceUsed', false);

export default selectLogMeLastWorkspaceUsed;
